import React from 'react';
import PropTypes from 'prop-types';

import useLanguage from '../../../hooks/useLanguage';

const Ticker = ({ tickerData }) => {
  const ticker = useLanguage(tickerData.ticker_ua, tickerData.ticker_ru);
  const sectionId = 'abs' + String(tickerData.id);
  const targetId = '#abs' + String(tickerData.id);
  return (
    <div className="ticker-main__container" id={sectionId} data-scroll-section>
      <div className="ticker-outline__wrapper ticker-wrapper">
        <span
          className="ticker ticker-outline"
          data-scroll=""
          data-scroll-direction="horizontal"
          data-scroll-speed="-2"
          data-scroll-target={targetId}
        >
          {ticker + ' • ' + ticker + ' • ' + ticker + ' • ' + ticker}
        </span>
      </div>
      <div className="ticker-fill__wrapper ticker-wrapper">
        <span
          className="ticker ticker-fill"
          data-scroll=""
          data-scroll-direction="horizontal"
          data-scroll-speed="2"
          data-scroll-target={targetId}
        >
          {ticker + ' • ' + ticker + ' • ' + ticker + ' • ' + ticker}
        </span>
      </div>
    </div>
  );
};

Ticker.propTypes = {
  tickerData: PropTypes.object,
};

export default Ticker;
